// // src/line/components/LineGuard.jsx
// import React, { useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';

// export default function LineGuard({ children }) {
//   const nav = useNavigate();
//   const loc = useLocation();

//   useEffect(() => {
//     const ua = navigator.userAgent || '';
//     const isMobile = /iPhone|Android|iPad|iPod|Mobile/i.test(ua);
//     const isLine = /Line\/|LINE\//.test(ua); // LINEアプリ内ブラウザ判定

//     // PC は公式サイトへ
//     if (!isMobile) {
//       window.location.href = 'https://kitamura.clinic';
//       return;
//     }

//     // モバイルでも LINE 以外は案内ページへ
//     if (!isLine && loc.pathname !== '/open-in-line') {
//       nav('/open-in-line', { replace: true });
//       return;
//     }
//   }, [nav, loc.pathname]);

//   return <>{children}</>;
// }


// src/line/components/LineGuard.jsx
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function LineGuard({ children }) {
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    const ua = navigator.userAgent || '';
    const isMobile = /iPhone|Android|iPad|iPod|Mobile/i.test(ua);
    const isLine = /Line\/|LINE\//.test(ua);

    if (!isMobile) {
      window.location.replace('https://kitamura.clinic');
      return;
    }

    // LINE 以外のモバイル → open-in-line へ。元のパスを to= に乗せる
    if (!isLine && loc.pathname !== '/open-in-line') {
      const to = encodeURIComponent(loc.pathname); // ex) /book, /my, /all, /reservation
      nav(`/open-in-line?to=${to}`, { replace: true });
    }
  }, [nav, loc.pathname]);

  return <>{children}</>;
}
